import React from 'react'
import { Container, Row, Col } from 'react-bootstrap';
import Footer from '../Footer/Footer';
import Getintouch from '../Gettouch/Getintouch';
import animatedv from '../assets/images/animated-video.png';
import TextBanner from '../components/TextBanner';
// import InnerSlider from '../components/InnerSlider';
import DynamicSlider from '../components/DynamicSlider';


import designer from '../assets/images/animated_video1.png';
import dance from '../assets/images/animated_video2.png';
import redteam from '../assets/images/animated_video3.png';
import developer from '../assets/images/whoslider4.png';

const AnimatedVideo = () => {
  const sliderItems = [
    {
      image: designer,
      alt: 'Designer',
      title: 'Designer Team',
      description: 'Designer Team Description for Slider Item'
    },
    {
      image: dance,
      alt: 'Dance',
      title: 'Dance Team',
      description: 'Dance Team Description for Slider Item'
    },
    {
      image: redteam,
      alt: 'redcube',
      title: 'redcube team',
      description: 'Redcube team Description for Slider Item 3'
    },
    {
      image: developer,
      alt: 'developer',
      title: 'developer team',
      description: 'Developer Team Description for Slider Item 3'
    }
  ];



  return (
    <div>  
        {/* new banner dynamic */}
            <TextBanner
              imageUrl={animatedv}
              altname="Animation Explainer Videos"
              title="Ditch the Wall of Text, Captivate Your Audience with Animation Explainer Videos!"  
            />
        {/*  new banner dynamic end */}
      

       
        {/* top slider  */}

          <DynamicSlider sliderItems={sliderItems} />

        {/* top slider  */}

         
        {/* text only section */}
          <section className='normaltext'>
            <Container>
              <Row>
                <Col lg={10} className='m-auto'>
                  <p>Forget dry pitches and mind-numbing texts. In today's attention-grabbing digital world, you need to hook your audience in seconds. That's where animated explainer videos come in - think vibrant visuals, captivating stories, and a sprinkle of animation magic to transform complex ideas into bite-sized brilliance. </p>
                </Col>
              </Row>
            </Container>
          </section>
        {/* text only section end */}


        {/* Imagine this */}
          <section>
            <Container>
              <Row>
              <Col lg={10} className='m-auto'>
                <h3 className='Imagine_center'>Imagine this: </h3>
              </Col>
                <Col lg={10} className='m-auto'>
                  <Row> 
                        <Col lg={4}>
                          <div className="playful_cartoon_box"> 
                          <p>A playful cartoon character takes viewers on a journey through your innovative product, its features popping to life with every tap of their virtual feet.</p>
                          </div>              
                        </Col>
                        <Col lg={4}>
                          <div className="playful_cartoon_box"> 
                          <p>A whiteboard artist sketches your service's benefits in real-time, each stroke revealing the "aha!" moment your audience craves.</p>
                          </div>              
                        </Col>
                        <Col lg={4}>
                          <div className="playful_cartoon_box"> 
                          <p>A stop-motion animation brings your brand story to life, building an emotional connection that static images simply can't match.</p>
                          </div>              
                        </Col>            
                  </Row>

                </Col>
              </Row>
            </Container>
          </section>        
        
        {/* Imagine this end */}

        {/* possibilities are endless */}

            <section className="possibilities_endless">
              <Container>
                <Row>
                  <Col lg={11} className='mx-auto'>
                    <div className="boost_engagement">
                      <h1 className="benefits">The possibilities are endless, and the benefits are clear:</h1>
                      <div class="keeping_them">
                        <h2>Boost engagement</h2>
                        <p>Forget scroll-and-snooze. Explainer videos captivate viewers 2x longer than text, keeping them glued to their screens (and your message).</p>
                      </div>
                      <div class="keeping_them">
                          <h2>Simplify the complex</h2>
                          <p>Break down complex concepts into digestible animated chunks, making even the most technical jargon crystal clear. </p>
                      </div>
                      <div class="keeping_them">
                          <h2>Boost conversions</h2>
                          <p>Explainer videos can increase conversion rates by up to 80%, turning curious clickers into loyal customers. </p>
                      </div>
                      <div class="keeping_them">
                          <h2>Build brand personality</h2>
                          <p>Inject your brand with personality and emotion through animation, making you stand out from the crowd. </p>
                      </div>

                      <div class="alchemists">                         
                          <p>We're the animation alchemists who turn your vision into video gold. Our team of master storytellers, skilled animators, and tech wizards collaborate to craft explainer videos that are as unique as your brand and as impactful as your goals. </p>
                      </div>

                    </div>
                  </Col>
                </Row>
              </Container>
            </section>
        {/* possibilities are endless end */}



        {/* our_magic  */}
          <section className="our_magic">
            <Container>
              <Row>
                <Col lg={11} className='mx-auto'>
                <div className="boost_engagement">
                      <h1 className="benefits">Here's how we work our magic:</h1>

                        <div className="keeping_them align-items f-magic">
                            <h5 className="round_bg">1</h5>
                            <div className="text-center_right">
                                <h2>Concept Alchemy</h2>
                                <p>We delve deep into your brand story, goals, and target audience to concoct the perfect video concept.</p>
                            </div>
                        </div>               

                        <div className="keeping_them align-items f-magic">
                            <h5 className="round_bg">2</h5>
                            <div className="text-center_right">
                                <h2>Script Sorcery</h2>
                                <p>We weave words into a captivating narrative, infused with humor, emotion, and the power of storytelling.</p>
                            </div>

                        </div>

                        <div className="keeping_them align-items f-magic">
                            <h5 className="round_bg">3</h5>
                            <div className="text-center_right">
                                <h2>Animation Awesomeness</h2>
                                <p>From whiteboard magic to 2D and 3D animation, we choose the style that best amplifies your message.</p>
                            </div>
                        </div>

                        <div className="keeping_them align-items f-magic">
                            <h5 className="round_bg">4</h5>
                            <div className="text-center_right">
                                <h2>Sound Symphony</h2>
                                <p>We craft the perfect soundscape, from catchy jingles to heart-pounding sound effects, to immerse your audience.</p>
                            </div>
                        </div>
                        <div className="keeping_them align-items f-magic">
                            <h5 className="round_bg">5</h5>
                            <div className="text-center_right">
                                <h2>Marketing Mastermind</h2>
                                <p>We tailor your video for optimal distribution, ensuring it reaches the right eye and ignites action.</p>
                            </div>
                        </div>

                        <div class="alchemists embrace_text">              
                            <p>Ready to ditch the dull and embrace the dazzling? Let's chat about how an animated explainer video can transform your brand story and skyrocket your success. Animation isn't just trend; it's a powerful tool to connect, convert, and conquer the digital world. Let's make your brand story the next animation masterpiece. </p>
                        </div>





                </div>
                </Col>
              </Row>
            </Container>
          </section>
        {/* our_magic end */}

      {/* get in touch */}
      <section className='p-0'>
        <Getintouch />
      </section>

      {/* Footer  */}
      <section className='p-0' >
        <Footer />
      </section>


    </div>
  )
}

export default AnimatedVideo
